import { Gender } from "../Gender";

export const mobileMenu = {
    menuOpen: false,
    submenuOpen: false,
    gender: "men",
    init: function () {
        this.updateGender();
        this.$watch("menuOpen", (val) => {
            if (!val) this.submenuOpen = false;
        });
    },
    setGender(gender) {
        Gender.setGender(gender);
    },
    toggle: function () {
        this.menuOpen ? this.close() : this.open();
    },
    open: function () {
        this.menuOpen = true;
    },
    close: function () {
        this.menuOpen = false;
    },
    closeSubmenu: function () {
        this.submenuOpen = false;
    },
    unload: function ($section) {},
    updateGender() {
        this.gender = Gender.getGender();
        this.closeSubmenu();
    },
};
